

















































































































































































































import Vue from 'vue'
import { Select, Option } from 'element-ui'
import VuMeter from '@/components/VuMeter'
import VideoDisplay from './VideoDisplay'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import CasterCommunication from '@/components/CasterCommunication'
import helpers from '../../helpers'
import { UserProfile } from '@/types/users'
import { VideoObjectNetworkStats } from '@/classes/VideoObjectNetworkStats'
import { UserNetworkStats } from '@/types/networkstats'
import fb from '@/firebase'  // FIXME -> needs to go
import { isMobile } from 'mobile-device-detect'
import { StreamType, talkbackTargetType } from '@/types/streams'
import { debounce } from 'lodash'
import { LogMessage } from '@/store/modules/logs'
import { CallTriage } from '@/types/casts'

interface Resolution {
  width: number,
  height: number
}

const resolutionsToCheck: Resolution[] = [
  { width: 640, height: 360 },
  { width: 320, height: 180 },
  { width: 160, height: 90 },
  { width: 1280, height: 720 },
  { width: 1920, height: 1080 }
]

interface DeviceOption {
  value: string,
  text: string,
  deviceId: string
}

export default Vue.extend({
  name: 'CameraMicControls',
  props: {
    user: {
      type: String,
      required: true,
      default: ''
    },
    castId: {
      type: String,
      required: false,
      default: ''
    },
    wrtcserver: {
      type: String,
      required: true
    },
    stream: {
      type: MediaStream,
      default: null
    },
    onAir: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    canCast: {
      type: Boolean,
      default: false
    },
    team: {
      type: String
    },
    presenceId: {
      type: String   // TODO
    },
    k360eventId: {
      type: Number
    },
    selfMute: {
      type: Boolean,
      required: false,
      default: false
    },
    testStreamName: {
      type: String,
      default: ''
    },
    showStopButton: {
      type: Boolean,
      default: true
    },
    streamsManager: {
      type: Object
    },
    sourceStreams: {
      type: Object
    },
    selfTest: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'advanced',
      required: false
    }
  },
  computed: {
    isInTeam (): boolean {
      const userId = this.$store.direct.getters.user.currentUserId
      const castTeam = this.$store.direct.state.events.castTeam
      const profile = castTeam.find((profile) => profile.id === userId)
      return !!profile
    },
    checkModeratorTooltip (): string {
      let tooltip = 'Only members of this team can connect as a moderator'
      if (this.isInTeam) tooltip = 'Allows to connect your webcam and qualify incoming guests through videochat'
      return tooltip
    },
    showTalkback (): boolean {
      return !!this.stream?.getAudioTracks()?.length && !this.canCast
    },
    lowrateVideoBitrate (): number {
      if (this.requiredVideoBitrate !== undefined && this.requiredVideoBitrate > 2000) return 1200
      return 320
    },
    needCamera (): boolean {
      return this.canCast || this.isModerator
    },
    isModerator: {
      get (): boolean {
        const moderators = this.$store.direct.state.events.currentCast.moderators
        if (moderators === undefined) return false
        const moderator = moderators[this.user]
        if (moderator === undefined) return false
        return moderator.connected && this.isInTeam
      },
      set (checked: boolean): void {
        this.$store.direct.dispatch.events.makeUserModerator({
          user: this.user,
          cast: this.castId,
          connected: checked
        }).catch((error) => {
          console.error('Could not change moderator state of cast', error)
        })
      }
    },
    talkbackTargetFallback (): string {
      return this.$store.direct.state.streams.talkbackTargetFallback
    },
    userProfile (): UserProfile | null {
      return this.$store.direct.state.user.profile
    },
    isCrewTalkBackActive (): boolean {
      const target = this.$store.direct.state.streams.talkbackTargetCaster
      return target === talkbackTargetType.CREW
    },
    casterIsActiveTalkbackTarget (): boolean {
      if (!this.$store.direct.getters.events.currentUserIsACaster) return false
      const userId = this.$store.direct.getters.user.currentUserId
      for (const [castStreamId, castStream] of Object.entries(this.$store.direct.state.streams.castStreams)) {
        if (![StreamType.NonCaster, StreamType.Moderator].includes(castStream.type)) continue
        const streamDoc = this.$store.direct.getters.events.streamDoc(castStreamId)
        // TODO: Do we also want the talkback indication when talkback ALL is active?
        if (userId !== '' && streamDoc?.talkbackTarget === userId) {
          return true
        }
      }
      return false
    },
    udpEnabled (): boolean {
      return this.userProfile && this.userProfile.udpEnabled !== undefined ? this.userProfile.udpEnabled : false
    },
    republish (): boolean {
      return this.$store.direct.state.user.needRepublish
    },
    publishType (): StreamType {
      if (this.canCast) return StreamType.Caster
      return this.isModerator ? StreamType.Moderator : StreamType.NonCaster
    },
    deviceSelected (): boolean {
      if (this.needCamera && this.selectedVideoDevice === '') return false
      if (this.selectedAudioDevice === '') return false
      return true
    },
    requiredVideoBitrate (): number | undefined {
      return this.userProfile?.encoderSettings?.videoBitrate
    },
    requiredVideoWidth (): number | undefined {
      return this.userProfile?.encoderSettings?.width
    },
    requiredVideoHeight (): number | undefined {
      return this.userProfile?.encoderSettings?.height
    },
    requiredAudioBitrate (): number | undefined {
      return this.userProfile?.encoderSettings?.audioBitrate
    },
    makeLowrateVariant (): boolean {
      return this.requiredVideoBitrate !== undefined && this.requiredVideoBitrate >= (this.defaultVideoBitRate * 2)
    },
    isMac (): boolean {
      return helpers.isMac()
    },
    echoSuppression (): boolean {
      return this.userProfile !== null && this.userProfile.echoSuppression !== undefined ? this.userProfile.echoSuppression : false
    },
    noiseSuppression (): boolean {
      return false
    },
    showLoginButton (): boolean {
      const cast = this.$store.direct.state.events.currentCast
      const invitedCasters = cast?.invited_casters
      const userId = this.userProfile?.id
      if (!cast || !invitedCasters || !userId || !invitedCasters[userId]) return false
      const showLoginButtonTriages = [CallTriage.Queued, CallTriage.Unverified]
      return showLoginButtonTriages.includes(invitedCasters[userId].triage)
    }
  },
  data: () => ({
    showDropdown: false,
    video: {},
    selectedVideoDevice: '',
    selectedAudioDevice: '',
    audioDevices: [] as DeviceOption[],
    audioOutputDevices: [] as DeviceOption[],
    videoDevices: [{ text: 'None', value: '', deviceId: '' }] as DeviceOption[],
    deviceConfigChanged: false,
    saveId: null as null|string,
    streamReady: false,
    talkStatus: false,
    supportedResolutions: [] as Resolution[],
    checkedResolution: 0,
    statslogcounter: 0,
    camerapermission: false,
    microphonepermission: false,
    startCastingClicked: false,
    srcPrefix: '',
    error: '',
    detectingDevices: false,
    currentRate: 0,
    initialized: false,
    showTooltip: true,
    showTooltipLogin: true,
    toolTipDuration: 5000, // ms
    defaultVideoBitRate: 320,
    lowrateAudioBitrate: 32,
    selectedWRTCServer: '',
    debounceGetDevices: undefined as EventListener|undefined
  }),
  watch: {
    selectedAudioDevice () {
      this.deviceConfigChanged = true
      this.updateSelectedDevices()
    },
    selectedVideoDevice () {
      this.deviceConfigChanged = true
      this.updateSelectedDevices()
    },
    stream () {
      if (!this.streamReady) {
        if (this.stream) {
          this.streamReady = true
          if (this.stream.getAudioTracks().length > 0 && !this.canCast) {
            this.stream.getAudioTracks()[0].enabled = false
          }
        }
      }
    },
    selfMute () {
      if (this.streamReady && this.stream !== null && this.stream.getAudioTracks().length > 0) {
        this.stream.getAudioTracks()[0].enabled = !this.selfMute
      }
    },
    active () {
      this.becomeActive()
    },
    canCast (newVal: boolean, oldVal: boolean) {
      if (newVal === false && oldVal === true) {
        this.goOffAir()
      } else if (newVal === true && oldVal === false && this.isModerator) {
        this.isModerator = false
      }
    },
    needCamera (newVal: boolean, oldVal: boolean): void {
      // Make sure the camera permission gets requested when we don't have it yet.
      if (newVal === true && oldVal === false && !this.camerapermission) {
        // E.g. clicking join as moderator in the drowpdown.
        if (this.showDropdown) this.init()
        // E.g. when "crew" -> "caster", then wait until user clicks "Cast" button to show dropdown.
        else this.initialized = false
      }
    },
    republish (newVal: boolean) {
      if (newVal === true) {
        this.goOffAir()
        this.saveId = null
        this.startStream()
        this.$store.direct.dispatch.user.needRepublish(false)
      }
    }
  },
  mounted () {
    if (this.userProfile?.anonymous) this.toolTipDuration = 15000
    this.srcPrefix = `rtsp://${this.wrtcserver}:1935/livetcp/`
    if (this.selfTest || this.view === 'simple') this.init()

    // Listen to MediaDevices API ondevicechange event
    // see https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/ondevicechange
    navigator.mediaDevices.addEventListener('devicechange', this.getDebounceGetDevices())

    setTimeout(() => {
      this.showTooltip = false
      this.showTooltipLogin = false
    }, this.toolTipDuration)
  },
  beforeDestroy () {
    // console.log('DESTROY')
    this.pageClosing()
    navigator.mediaDevices.removeEventListener('devicechange', this.getDebounceGetDevices())
  },
  methods: {
    getDebounceGetDevices (): EventListener {
      if (this.debounceGetDevices === undefined) {
        // needs debounce because is triggered more than once even for one device (eg headset with mic = input + output)
        // debounce of eg 100ms = all devices connected in this time will trigger a single update
        this.debounceGetDevices = debounce((_event) => {
          console.warn('-- ondevicechange / update input/output devices --')
          this.getDevices()
        }, 100) as EventListener
      }
      return this.debounceGetDevices
    },
    closeDropdown () {
      this.showDropdown = false
    },
    toggleDropdown () {
      if (!this.initialized) this.init()
      this.showDropdown = !this.showDropdown

      if (isMobile) this.maybeGoFullscreenLandscape()
    },
    async maybeGoFullscreenLandscape (lockToLandscape: boolean = true) {
      try {
        if (document.fullscreenEnabled && document.fullscreenElement === null) {
          await document.body.requestFullscreen()
        }
        // Note: We must be in fullscreen for orientation lock() to work.
        if (lockToLandscape && document.fullscreenElement !== null) {
          await window.screen.orientation.lock('landscape')
        }
      } catch {} // Silently ignore failures to go fullscreen or lock landscape.
    },
    init () {
      this.checkPermission()
      this.initialized = true
      if (this.active) this.becomeActive()
    },
    setConfigSelections () {
      if (isMobile) this.maybeGoFullscreenLandscape()
      this.$store.direct.dispatch.events.setAudioInit(true)
      this.startCastingClicked = true
      this.selectedWRTCServer = this.wrtcserver
      this.startStream()
      this.deviceConfigChanged = false
    },
    becomeActive () {
      this.detectingDevices = true
      if (this.needCamera && !(this.camerapermission && this.microphonepermission)) {
        this.askPermissions(['camera', 'microphone'])
      } else if (!this.canCast && !this.microphonepermission) {
        this.askPermissions(['microphone'])
      } else {
        this.askPermissions([])
      }
    },
    checkPermission () {
      navigator.permissions.query({ name: 'camera' }).then((result) => {
        this.camerapermission = result.state === 'granted'
      }).catch((error) => {
        this.camerapermission = false
        this.addLog({
          message: 'Could not find camera permissions',
          error: error
        })
      })
      navigator.permissions.query({ name: 'microphone' }).then((result) => {
        this.microphonepermission = result.state === 'granted'
      }).catch((error) => {
        this.microphonepermission = false
        this.addLog({
          message: 'Could not find microphone permissions',
          error: error
        })
      })
    },
    askPermissions (permissions) {
      if (permissions.length === 0) {
        this.getDevices()
      } else {
        const data = {} as { video?: boolean, audio?: boolean }
        if (permissions.includes('camera')) {
          data.video = true
        }
        if (permissions.includes('microphone')) {
          data.audio = true
        }
        navigator.mediaDevices.getUserMedia(data).then(stream => {
          stream.getTracks().forEach(track => {
            track.stop()
          })
          this.checkPermission()
          this.getDevices()
        }).catch((error) => {
          let logMessage = ''

          if (error.name === 'NotAllowedError') {
            logMessage = 'User denied permissions'
            this.error = 'Kiswe Studio does not have permission to access your camera/microphone. Go to our <a href="https://support.kiswe.com" target="_blank" style="color:rgb(242, 70, 55);"><u>support page</u></a> on this topic.'
          } else {
            const type = error.message.includes('video') ? 'video' : 'audio'
            this.error = `Unable to connect with your ${type} device, can you check if it is properly connected to your machine and not in use by any other application`
            logMessage = 'Could not get User Media'
          }

          this.addLog({
            message: logMessage,
            error: error
          })
        })
      }
    },
    updateSelectedDevices () {
      const profile: Partial<UserProfile> = { id: this.user }
      profile.selectedVideoDevice = this.selectedVideoDevice
      profile.selectedAudioDevice = this.selectedAudioDevice
      this.$store.direct.dispatch.user.updateProfile(profile)
    },
    getDevices () {
      console.log('-- getDevices --')
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const videoDevices : DeviceOption [] = []
        const audioOutputDevices : DeviceOption [] = []
        const audioDevices : DeviceOption [] = []
        const profile: Partial<UserProfile> = { id: this.user, devices: [] }
        navigator.mediaDevices.enumerateDevices().then(devices => {
          for (const device of devices) {
            if (device.kind === 'audioinput') {
              const text = device.label || `microphone ${this.audioDevices.length + 1}`
              audioDevices.push({ text, value: device.label, deviceId: device.deviceId })
              if (profile.devices) {
                profile.devices.push({ type: 'audio', name: text, id: device.deviceId })
              }
            } else if (device.kind === 'videoinput') {
              const text = device.label || `camera ${this.videoDevices.length + 1}`
              videoDevices.push({ text, value: device.label, deviceId: device.deviceId })
              if (profile.devices) {
                profile.devices.push({ type: 'video', name: device.label, id: device.deviceId })
              }
            } else if (device.kind === 'audiooutput') {
              const text = device.label || `speaker ${this.audioOutputDevices.length + 1}`
              audioOutputDevices.push({ text, value: device.label, deviceId: device.deviceId })
              if (profile.devices) {
                profile.devices.push({ type: 'output', name: device.label, id: device.deviceId })
              }
            }
          }
          this.videoDevices = videoDevices
          this.audioOutputDevices = audioOutputDevices
          this.audioDevices = audioDevices
          const audioFound = this.audioDevices.find(device => device.deviceId === this.selectedAudioDevice)
          const videoFound = this.videoDevices.find(device => device.deviceId === this.selectedVideoDevice)
          if (!audioFound) {
            this.selectedAudioDevice = ''
          }
          if (!videoFound) {
            this.selectedVideoDevice = ''
          }
          if (this.selectedAudioDevice === '' && this.audioDevices.length > 0) {
            this.selectedAudioDevice = this.audioDevices[0].deviceId
          }
          if (this.selectedVideoDevice === '' && this.videoDevices.length > 0) {
            this.selectedVideoDevice = this.videoDevices[0].deviceId
          }
          profile.selectedVideoDevice = this.selectedVideoDevice
          profile.selectedAudioDevice = this.selectedAudioDevice
          setTimeout(() => { this.detectingDevices = false }, 2000)
          this.$store.direct.dispatch.user.updateProfile(profile)
        }).catch((error) => {
          this.addLog({
            message: 'Could not find devices',
            error: error
          })
        })
      } else {
        this.addLog({
          message: 'Client browser does not support getUserMedia',
          level: 'error'
        })
      }
    },
    cleanStats (stat) {
      if (stat === undefined) return 0
      else return stat
    },
    onNetworkStats (stats: VideoObjectNetworkStats) {
      const caster = this.userProfile?.assignedId ?? this.user
      this.$store.direct.dispatch.logs.addLog({
        message: 'MetricReport: CasterNetwork',
        cast: this.castId,
        level: 'info',
        data: {
          jitter: stats.jitter,
          latency: stats.latency,
        },
        k360event: this.k360eventId,
        logger_name: 'metrics',
        caster
      })
      if (this.statslogcounter % 5 === 0) {
        this.$store.direct.dispatch.logs.addLog({
          message: `Bandwidth info of ${this.user} (score = ${stats.score})`,
          level: 'info',
          data: { stats: JSON.parse(JSON.stringify(stats)) }
        })
      }
      const profileStats: UserNetworkStats = {
        upload: {
          jitter: this.cleanStats(stats.jitter),
          latency: this.cleanStats(stats.latency),
          score: this.cleanStats(stats.score),
          bandwidth: this.cleanStats(stats.upload),
          region: this.userProfile?.transcodingregion ?? 'unknown'
        },
        download: {
          bandwidth: this.cleanStats(stats.download)
        }
      }
      if (stats.encoder !== undefined) {
        profileStats.encoder = {
          adaptation: this.cleanStats(stats.encoder.adaptation),
          cpu_usage: this.cleanStats(stats.encoder.cpu_usage),
          fps_in: this.cleanStats(stats.encoder.fps_in),
          fps_out: this.cleanStats(stats.encoder.fps_out),
          width: this.cleanStats(stats.encoder.width),
          height: this.cleanStats(stats.encoder.height),
          video_bitrate: this.cleanStats(stats.encoder.video_bitrate),
          audio_bitrate: this.cleanStats(stats.encoder.audio_bitrate)
        }
      }
      this.$store.direct.dispatch.user.updateStats(profileStats)
      this.statslogcounter += 1
    },
    startStream () {
      this.addLog({ message: 'Starting caster stream' })
      if (this.selectedVideoDevice !== '' && this.needCamera) {
        this.streamReady = false
        this.startCheckingResolutions()
      } else {
        this.connectAudioOnly()
      }
    },
    audioConstraints (audioSource) {
      if (isMobile) {
        return {
          deviceId: audioSource ? { exact: audioSource } : undefined
        }
      }
      return {
        deviceId: audioSource ? { exact: audioSource } : undefined,
        echoCancellation: this.echoSuppression,
        googEchoCancellation: this.echoSuppression,
        googNoiseSuppression: this.echoSuppression
      }
    },
    connectAudioOnly () {
      this.addLog({ message: 'Connect audio only' })
      this.saveId = null
      const audioSource = this.selectedAudioDevice
      const constraints = {
        audio: this.audioConstraints(audioSource)
      }
      navigator.mediaDevices.getUserMedia(constraints).then(this.gotStream).then(() => {
        if (this.onAir === false) {
          if (this.saveId === null) {
            if (this.testStreamName === '' && this.error === '') {
              this.addStreamReference()
            }
          }
        }
      }).catch(this.handleError)
    },
    startCheckingResolutions () {
      this.checkedResolution = 0
      this.currentRate = 0
      this.supportedResolutions = []
      this.getSupportedResolutions()
    },
    getSupportedResolutions () {
      if (this.checkedResolution >= resolutionsToCheck.length) {
        this.onSupportedResolutionFinished()
      } else {
        const resolution = resolutionsToCheck[this.checkedResolution]
        const videoSource = this.selectedVideoDevice
        const temporaryConstraints = {
          audio: true,
          video: {
            width: { exact: resolution.width },
            height: { exact: resolution.height },
            deviceId: videoSource ? { exact: videoSource } : undefined,
            frameRate: { max: 30 }
          }
        }
        navigator.mediaDevices.getUserMedia(temporaryConstraints).then(this.checkSuccess).catch(this.checkError)
      }
    },
    checkSuccess (stream) {
      if (this.currentRate === 0) {
        const audioContext = new AudioContext()
        const microphone = audioContext.createMediaStreamSource(stream)
        this.currentRate = microphone.context.sampleRate
        audioContext.close()
      }
      const resolution = resolutionsToCheck[this.checkedResolution]
      console.log('Resolution available ' + JSON.stringify(resolution))
      this.supportedResolutions.push(resolution)
      this.checkedResolution += 1
      for (const track of stream.getTracks()) {
        track.stop()
      }
      this.getSupportedResolutions()
    },
    checkError (error) {
      const resolution = resolutionsToCheck[this.checkedResolution]
      this.$store.direct.dispatch.logs.addLog({
        message: 'error connecting to devices to cast with.',
        error,
        data: { resolution },
        level: 'error'
      })
      this.checkedResolution += 1
      this.getSupportedResolutions()
    },
    getOptimalSupportedResolution (): Resolution|undefined {
      if (this.supportedResolutions.length === 0) return undefined
      const resolution = this.supportedResolutions.find(resolution => {
        resolution.width === this.requiredVideoWidth && resolution.height === this.requiredVideoHeight
      })
      if (resolution) return resolution
      return this.supportedResolutions[0]
    },
    onSupportedResolutionFinished () {
      this.error = ''
      if (this.supportedResolutions.length === 0) {
        this.error = 'Camera does not support 16:9 aspect ratio, please verify that the camera is connected and '
        this.error += 'no other program or tab is using the camera and try again.'
        this.startCastingClicked = false
        this.addLog({
          message: 'Camera does not support 16:9 aspect ratio',
          level: 'error'
        })
        return
      }
      this.saveId = null
      const audioSource = this.selectedAudioDevice
      const videoSource = this.selectedVideoDevice
      //
      const constraints: MediaStreamConstraints = {
        audio: this.audioConstraints(audioSource)
      }
      const resolution = this.getOptimalSupportedResolution()
      if (resolution === undefined) {
        console.error('CameraMicControls::onSupportedResolutionFinished: no supported resolutions')
        return
      }
      let width = resolution.width
      let height = resolution.height

      if (this.userProfile?.encoderSettings?.width !== undefined && this.userProfile?.encoderSettings?.height !== undefined) {
        const resolutionExists = this.supportedResolutions.find(resolution => {
          if (resolution.width !== this.userProfile?.encoderSettings?.width) return false
          if (resolution.height !== this.userProfile?.encoderSettings?.height) return false
          return true
        })
        if (resolutionExists) {
          width = this.userProfile.encoderSettings.width
          height = this.userProfile.encoderSettings.height
        }
      } else {
        this.addLog({
          message: 'Encoder settings width or height is undefined',
          data: { encoderSettings: this.userProfile?.encoderSettings },
          level: 'error'
        })
      }

      if (this.needCamera && this.selectedVideoDevice !== '') {
        constraints.video = {
          width: { exact: width },
          height: { exact: height },
          deviceId: videoSource ? { exact: videoSource } : undefined,
          frameRate: { max: 30 }
        }
      }
      console.log('constraints', constraints)
      this.$store.direct.dispatch.logs.addLog({
        message: 'Starting caster camera with constraints ' + JSON.stringify(constraints),
        data: { constraints },
        cast: this.castId, level: 'info'
      })
      navigator.mediaDevices.getUserMedia(constraints).then(this.gotStream).then(() => {
        console.log(this.onAir + ' ' + this.republish)
        if (this.onAir === false || this.republish) {
          if (this.saveId === null && this.error === '') {
            if (this.testStreamName === '') {
              this.addStreamReference()
            } else {
              this.saveId = this.testStreamName
              this.$emit('setCurrentCasterStream', { streamId: this.saveId })
            }
          }
        }
      }).catch(this.handleError)
    },
    goOffAir () {
      if (isMobile && window.screen.orientation) {
        console.log('UNLOCK screen.orientation')
        window.screen.orientation.unlock()
      }
      if (this.selfMute) this.$emit('toggleSelfMute', false) //Update state for button to unmuted for if user recasts
      this.enableCrewTalkback(false)
      this.startCastingClicked = false
      this.$emit('killLocalCameraStream')
      this.addLog({
        message: 'Stop casting has been clicked.',
        data: { stream_id: this.saveId },
      })
    },
    gotStream (stream) {
      console.log('gotStream ', stream)
      if (this.currentRate > 96000) {
        this.$store.direct.dispatch.logs.addLog({
          message: 'samplerate too high',
          cast: this.castId,
          data: { rate: this.currentRate },
          level: 'info'
        })
        this.error = 'Your microphone has a samplerate of ' + (this.currentRate / 1000) + 'kHz, Kiswe Studio only supports up to 96kHz. '
        this.error += 'For more details, go to our <a href="https://support.kiswe.com" target="_blank" style="color:rgb(242, 70, 55);"><u>support page</u></a> on this topic'
      } else {
        this.$emit('setLocalCameraStream', stream)
        this.$store.direct.dispatch.logs.addLog({
          message: 'got the local camera stream',
          cast: this.castId,
          level: 'info'
        })
      }
      this.startCastingClicked = false
    },
    addStreamReference () {
      this.$store.direct.dispatch.events.setCasting(true)
      const pubts = Math.round(Date.now() / 1000)
      const newsref = fb.db.collection('streams').doc()
      this.saveId = newsref.id
      this.srcPrefix = `rtsp://${this.selectedWRTCServer}:1935/livetcp/`
      if (newsref.id !== '') {
        fb.db.collection('streams').doc(newsref.id).set({
          user: this.user,
          active: true,
          persistent: false,
          team_id: this.team,
          srcurl: `${this.srcPrefix}${this.saveId}`,
          type: this.publishType,
          pubts: pubts
        }).then(this.streamRefSuccess).catch(this.streamRefFailure)
      }
    },
    streamRefSuccess () {
      const currentCasterStream =  {
        streamId: this.saveId,
        userId: this.user,
        type: this.publishType,
        sessionId: this.presenceId,
        talkbackTarget: talkbackTargetType.NONE
      }
      this.$emit('setCurrentCasterStream', currentCasterStream)

      this.addLog({
        message: 'Stream reference made for new caster stream',
        data: {
          caster_type: this.publishType,
          stream_id: this.saveId
        }
      })
    },
    toggleCrewTalkback () {
      const isActive = !this.isCrewTalkBackActive
      this.enableCrewTalkback(isActive)
    },
    enableCrewTalkback (enabled: boolean) {
      const target = (enabled) ? talkbackTargetType.CREW : talkbackTargetType.NONE
      this.$store.direct.dispatch.streams.setTalkbackFallback(target)
      this.updateTalkback(enabled, target)
    },
    enterAllTalkback (): void {
      this.updateTalkback(true, talkbackTargetType.ALL)
    },
    leaveTalkback () {
      if (this.isCrewTalkBackActive) {
        return
      }

      console.log('leaveTalkback')

      if (this.talkbackTargetFallback === talkbackTargetType.CREW) {
        this.updateTalkback(true, talkbackTargetType.CREW)
        return
      }

      this.updateTalkback(false, talkbackTargetType.NONE)
    },
    updateTalkback (enabled: boolean, talkbackTarget: string): void {
      console.log('updateTalkback - target:', talkbackTarget)

      this.talkStatus = enabled && talkbackTarget === talkbackTargetType.ALL
      this.$store.direct.dispatch.logs.addLog({
        message: `Talkback button pressed. Direction: ${enabled} Target: ${talkbackTarget}`,
        level: 'info'
      })
      this.$store.direct.dispatch.streams.setTalkbackTarget(talkbackTarget)
      if (this.stream !== null && this.stream.getAudioTracks().length > 0) {
        console.warn('ENABLE TALKBACK', enabled, talkbackTarget)
        this.stream.getAudioTracks()[0].enabled = enabled
      }
    },
    toggleSelfMute () {
      if (this.stream !== null && this.stream.getAudioTracks().length > 0) {
        this.stream.getAudioTracks()[0].enabled = !this.selfMute //Toggle actual device mute
      }
      this.$emit('toggleSelfMute', !this.selfMute) //Update state for button
    },
    pageClosing () {
      this.$emit('killLocalCameraStream')
      this.addLog({
        message: 'Page has been closed so we are stopping our cast stream',
        data: {
          caster_type: this.publishType,
          stream_id: this.saveId
        }
      })
    },
    streamRefFailure (error) {
      this.addLog({
        message: 'streamRefFailure',
        error: error
      })
    },
    wsConnectionClosed () {
      this.addLog({ message: 'wsConnectionClosed' })
    },
    handleError (error) {
      this.addLog({
        message: 'Error opening camera',
        error: error,
        data: {
          caster_type: this.publishType,
          stream_id: this.saveId,
        }
      })
    },
    addLog ({ message, data = {}, level = 'info', error = null} : { message: string, data?: any, level?: 'info' | 'error', error?: any }): void {
      let lvl = level
      if (!lvl) {
        if (error) lvl = 'error'
        else lvl = 'info'
      }

      const payload: LogMessage = {
        message: (error) ? message + ' | ' + error : message,
        cast: this.castId,
        data: data,
        level: lvl as LogMessage['level']
      }

      this.$store.direct.dispatch.logs.addLog(payload)

      if (error) console.error(message, error)
      else console.log(message)
    },
    async goToLogin (): Promise<void> {
      this.$router.push({ name: 'logout' })
    }
  },
  components: {
    'el-select': Select,
    'el-option': Option,
    'clip-loader': ClipLoader,
    CasterCommunication,
    VuMeter,
    VideoDisplay
  }
})
